import { createSlice } from "@reduxjs/toolkit";
import { get_req } from "../Utilities/apiUtil";
import {
  get_all_cities_url,
  get_is_special_city_url,
} from "../Utilities/apiUrl";
import { errorActions } from "../store/errorSlice";
import appConst from "../Utilities/appConst.json";

export const fetchAllCities = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      try {
        const data = await get_req(get_all_cities_url);
        dispatch(errorActions.setError(!data.isValid));
        return data;
      } catch (error) {
        dispatch(errorActions.setError(true));
      }
    };
    try {
      const cities = await fetchData();
      dispatch(errorActions.setError(!cities.isValid));
      dispatch(citiesActions.setCities(cities));
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
  };
};

const citiesSlice = createSlice({
  name: "cities",
  initialState: {
    cities: [],
    citiesObject: [],
    cityName: "",
    otherReseiverCityName: "",
    businessInvoiceCityName: "",
    isSpecialCity: false,
  },
  reducers: {
    setCities: (state, action) => {
      const citiesObject = [
        ...action.payload.payload.filter((city) => city !== "").slice(),
      ];
      state.citiesObject = citiesObject;

      const citiesArray = citiesObject
        .map((city) => city.city)
        .filter((city) => city !== "");
      state.cities = [...new Set(citiesArray)];
    },
    setCityName: (state, action) => {
      const cityName = action.payload.cityName;
      const selctedCityObject = state.citiesObject.find(
        (city) => city.city === cityName
      );
      state.isSpecialCity = selctedCityObject
        ? selctedCityObject.is_special_city === 1
        : false;

      switch (action.payload.prefix) {
        case appConst.OTHER_RECEIVER + "_":
          state.otherReseiverCityName = state.cities.find(
            (item) => item === cityName
          );
          break;
        case appConst.BUSINESS_INVOICE + "_":
          state.businessInvoiceCityName = state.cities.find(
            (item) => item === cityName
          );
          break;
        default:
          state.cityName = state.cities.find((item) => item === cityName);
      }
    },
  },
});
export const citiesActions = citiesSlice.actions;
export default citiesSlice;
